import PropTypes from 'prop-types';
import Box from 'components/UI/Box/Box';
import userImg from 'assets/images/default_avatar.jpg';

/** Catálogo presentacional REFERIDOS - ESTATUS SAP. */
export const STATUS_LABELS = {
  '01': 'Preregistro',
  '02': 'Contrato creado',
  '03': 'Primer pago en línea',
  '04': 'Completado',
  '05': 'Cancelado',
  '06': 'Vencido',
  '07': 'Retenidos',
};
export const COMPLETED_STEPS_BY_STATUS = {
  '01': 1,
  '02': 2,
  '03': 3,
  '04': 4,
};

export const mapStatusLabel = (value, missingLabel) => {
  if (value === null || value === undefined) return missingLabel;
  const key = String(value);
  return STATUS_LABELS[key] ?? key;
};

export const getCompletedSteps = (value) => {
  if (value === null || value === undefined) return 0;
  return COMPLETED_STEPS_BY_STATUS[String(value)] ?? 0;
};

const formatMainPoints = (value, missingLabel, ptsLabel) => {
  if (typeof value !== 'number') return missingLabel;
  return `${value} ${ptsLabel}`;
};

const formatRaw = (value, missingLabel) => {
  if (value === null || value === undefined || value === '') return missingLabel;
  return String(value);
};

/** YYYY-MM-DD del ISO, sin convertir zona horaria. */
export const formatReferralDate = (value, missingLabel) => {
  if (typeof value !== 'string' || !value.trim()) {
    return missingLabel;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/.exec(value);

  if (!match) return formatRaw(value, missingLabel);

  return `${match[1]}/${match[2]}/${match[3]}`;
};

const STAGE_KEYS = [
  'stagePreregistro',
  'stageContrato',
  'stagePago',
  'stageBonificacion',
];

const ReferralListItem = ({ item, literals }) => {
  const displayName = (item.NombreClienteReferido === null
    || item.NombreClienteReferido === undefined)
    ? literals.valueMissing
    : String(item.NombreClienteReferido);
  const statusLabel = mapStatusLabel(item.Estatus, literals.valueMissing);
  const completedSteps = getCompletedSteps(item.Estatus);
  const progressPercent = (completedSteps / 4) * 100;
  const registeredAt = formatReferralDate(
    item.FechaRegistro,
    literals.valueMissing,
  );

  return (
    <Box className='referral-list-item mb-3' padding='sm'>
      <div className='referral-list-item__header'>
        <img
          className='referral-list-item__avatar'
          src={userImg}
          alt=''
        />
        <p className='referral-list-item__name mb-0'>{displayName}</p>
        <p className='referral-list-item__points mb-0'>
          {formatMainPoints(
            item.PuntosReferidor,
            literals.pointsMissing,
            literals.pts,
          )}
        </p>
      </div>

      <div className='referral-list-item__status-row'>
        <span className='referral-status'>{statusLabel}</span>
      </div>

      <p className='referral-list-item__registered mb-3'>
        {`${literals.registeredAt}: ${registeredAt}`}
      </p>

      <div className='referral-progress'>
        <div
          className='referral-progress__track'
          role='progressbar'
          aria-label={literals.progressLabel}
          aria-valuemin={0}
          aria-valuemax={4}
          aria-valuenow={completedSteps}
        >
          <div
            className='referral-progress__fill'
            style={{ width: `${progressPercent}%` }}
            data-testid='referral-progress-fill'
          />
        </div>
        <div className='referral-progress__steps'>
          {STAGE_KEYS.map((key, index) => {
            const done = index < completedSteps;
            return (
              <div
                key={key}
                className={
                  done
                    ? 'referral-progress__step referral-progress__step--done'
                    : 'referral-progress__step'
                }
                data-completed={done ? 'true' : 'false'}
              >
                {literals[key]}
              </div>
            );
          })}
        </div>
      </div>
    </Box>
  );
};

ReferralListItem.propTypes = {
  item: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
};

export default ReferralListItem;
